import * as Elevated from '@pitaman71/omniglot-introspect';

import * as Objects from './Objects';
import * as Stores from './Stores';
import * as Properties from './Properties';
import * as Proposals from './Proposals';
import * as Relations from './Relations';
import * as Streams from './Streams';

export class ProposeZone extends Stores.Zone {
    _local: Stores.Zone;

    constructor(
        slug: string,
        local: Stores.Zone
    ) {
        super();
        this._peerId = slug;
        this._local = local;
    }

    streams() {
        const zone = this;
        return new class extends Streams.Factory {
            properties(): Streams.PropertyStream<Properties.TypeParams>[] {
                return Array.from(zone._properties.values());
            }
            relations(): Streams.RelationStream<Objects.BindingType>[] {
                return Array.from(zone._relations.values());
            }
            property<PropertyTypeParams extends Properties.TypeParams>(
                instance: Properties.Instance<PropertyTypeParams>
            ): Streams.PropertyStream<PropertyTypeParams> {
                const key = Stores.Key.fromProperty<PropertyTypeParams["Binding"]>(instance.descriptor, instance.binding)
                let result: Streams.PropertyStream<PropertyTypeParams>|undefined = zone._properties.get(key.toString());
                const slug = `ProposeZone(${zone._peerId})${JSON.stringify(instance.binding)}`;
                if(result === undefined) {
                    instance.descriptor.build(new class implements Properties.Builder<PropertyTypeParams> {
                        object(objectSymbol: keyof PropertyTypeParams): void {}
                        measure(domain: PropertyTypeParams["Domain"]): void {}
                        example(maker: () => PropertyTypeParams["Value"]): void {}
                        scalar(): void {
                            const local = zone._local.streams().property(instance);
                            //new PersistZone.ScalarMutator(descriptor.bind(context_), descriptor.getDomain(), zone.local);
                            const mutator = new Proposals.ScalarMutator<PropertyTypeParams>(slug, instance, local.scalar);
                            result = { descriptor: instance.descriptor, instance, scalar: mutator };
                        }
                        set(): void {
                            const local = zone._local.streams().property(instance);
                            const mutator = new Proposals.SetMutator<PropertyTypeParams>(slug, instance, local.set);
                            result = { descriptor: instance.descriptor, instance, set: mutator };
                        }
                        sequence(): void {
                            const local = zone._local.streams().property(instance);
                            const mutator = new Proposals.SequenceMutator<PropertyTypeParams>(slug, instance, local.sequence);
                            result = { descriptor: instance.descriptor, instance, sequence: mutator };
                        }
                        map<KeyType>(makeKey: () => KeyType): void {
                            const local = zone._local.streams().property(instance);
                            const mutator = new Proposals.MapMutator<KeyType, PropertyTypeParams>(slug, instance, makeKey, local.map);
                            result = { descriptor: instance.descriptor, instance, map: mutator };
                        }
                    } )
                    if(result === undefined) {
                        throw new Error('Malformed Descriptor')
                    }        
                    zone._properties.set(key.toString(), result)
                }        
                return result;
            }
            relation<BindingType_ extends Objects.BindingType>(
                anchor: Relations.Anchor<BindingType_>
            ): Streams.RelationStream<BindingType_> {
                const key = Stores.Key.fromRelation(anchor.descriptor, anchor.binding)
                const slug = `ProposeZone(${zone._peerId})${JSON.stringify(anchor.binding)}`;
                let mutator: Streams.RelationStream<BindingType_>|undefined = zone._relations.get(key.toString());
                if(mutator === undefined) {
                    const local = zone._local.streams().relation(anchor);
                    mutator = new Proposals.RelationMutator<BindingType_>(slug, anchor, local);
                    if(mutator === undefined) {
                        throw new Error('Malformed Descriptor')
                    }        
                    zone._relations.set(key.toString(), mutator);
                }
                return mutator;
            }
        }
    }
}